/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FederalCourtDistrictEnum } from './FederalCourtDistrictEnum';
import {
    FederalCourtDistrictEnumFromJSON,
    FederalCourtDistrictEnumFromJSONTyped,
    FederalCourtDistrictEnumToJSON,
    FederalCourtDistrictEnumToJSONTyped,
} from './FederalCourtDistrictEnum';

/**
 * 
 * @export
 * @interface CourtProceedingCreate
 */
export interface CourtProceedingCreate {
    /**
     * Title of the court proceeding
     * @type {string}
     * @memberof CourtProceedingCreate
     */
    title: string;
    /**
     * Docket number (e.g., '1:20-cv-05227')
     * @type {string}
     * @memberof CourtProceedingCreate
     */
    docketNumber: string;
    /**
     * 
     * @type {Date}
     * @memberof CourtProceedingCreate
     */
    filingDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CourtProceedingCreate
     */
    url?: string | null;
    /**
     * Federal court district acronym
     * @type {FederalCourtDistrictEnum}
     * @memberof CourtProceedingCreate
     */
    courtDistrict: FederalCourtDistrictEnum;
    /**
     * 
     * @type {number}
     * @memberof CourtProceedingCreate
     */
    prosecutionId: number;
}



/**
 * Check if a given object implements the CourtProceedingCreate interface.
 */
export function instanceOfCourtProceedingCreate(value: object): value is CourtProceedingCreate {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('docketNumber' in value) || value['docketNumber'] === undefined) return false;
    if (!('courtDistrict' in value) || value['courtDistrict'] === undefined) return false;
    if (!('prosecutionId' in value) || value['prosecutionId'] === undefined) return false;
    return true;
}

export function CourtProceedingCreateFromJSON(json: any): CourtProceedingCreate {
    return CourtProceedingCreateFromJSONTyped(json, false);
}

export function CourtProceedingCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourtProceedingCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'docketNumber': json['docket_number'],
        'filingDate': json['filing_date'] == null ? undefined : (new Date(json['filing_date'])),
        'url': json['url'] == null ? undefined : json['url'],
        'courtDistrict': FederalCourtDistrictEnumFromJSON(json['court_district']),
        'prosecutionId': json['prosecution_id'],
    };
}

export function CourtProceedingCreateToJSON(json: any): CourtProceedingCreate {
    return CourtProceedingCreateToJSONTyped(json, false);
}

export function CourtProceedingCreateToJSONTyped(value?: CourtProceedingCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'docket_number': value['docketNumber'],
        'filing_date': value['filingDate'] == null ? undefined : ((value['filingDate'] as any).toISOString().substring(0,10)),
        'url': value['url'],
        'court_district': FederalCourtDistrictEnumToJSON(value['courtDistrict']),
        'prosecution_id': value['prosecutionId'],
    };
}

